<div class="bg-secondary flex size-full flex-col">
  @if (showHeader()) {
    <shared-core-header (logoClicked)="router.navigate([''])" class="h-fit">
      <shared-core-header-left-slot-outlet />
    </shared-core-header>
  }
  <div class="min-h-0 grow">
    <div class="h-full">
      <router-outlet></router-outlet>
      <shared-core-toast-container />
    </div>
  </div>
</div>
